import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

  // Dashboard - All roles
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/team-dashboard.component').then((m) => m.TeamDashboardComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'dashboard' },
  },

  // Reports - Admin, TL, CodeQualityResponsible
  {
    path: 'weekly-report',
    loadComponent: () => import('./pages/reports/weekly-report.component').then((m) => m.WeeklyReportComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'reports' },
  },
  {
    path: 'monthly-report',
    loadComponent: () => import('./pages/reports/monthly-report.component').then((m) => m.MonthlyReportComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'reports' },
  },
  {
    path: 'code-quality-report',
    loadComponent: () =>
      import('./pages/reports/code-quality-report.component').then((m) => m.CodeQualityReportComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'reports' },
  },
  {
    path: 'code-quality-report/:id',
    loadComponent: () =>
      import('./pages/reports/code-quality-report-detail.component').then((m) => m.CodeQualityReportDetailComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'reports' },
  },
  // Projects - Admin, TL
  {
    path: 'projects',
    loadComponent: () => import('./pages/projects/projects-list.component').then((m) => m.ProjectsListComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'projects' },
  },
  {
    path: 'projects/:key',
    loadComponent: () => import('./pages/projects/project-detail.component').then((m) => m.ProjectDetailComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'projects' },
  },

  // Quality Gates - Admin, TL, CodeQualityResponsible
  {
    path: 'quality-gates',
    loadComponent: () => import('./pages/quality-gates/quality-gates.component').then((m) => m.QualityGatesComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'qualityGates' },
  },
  {
    path: 'quality-gates/:id',
    loadComponent: () =>
      import('./pages/quality-gates/quality-gate-detail.component').then((m) => m.QualityGateDetailComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'qualityGates' },
  },

  // Users - Admin, TL (to add members to team)
  {
    path: 'users',
    loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'users' },
  },
  {
    path: 'users/:id',
    loadComponent: () => import('./pages/users/user-detail.component').then((m) => m.UserDetailComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'users' },
  },

  // Teams - Admin only
  {
    path: 'teams',
    loadComponent: () => import('./pages/teams/teams.component').then((m) => m.TeamsComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'teams' },
  },
  {
    path: 'teams/:id',
    loadComponent: () => import('./pages/teams/team-detail.component').then((m) => m.TeamDetailComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'teams' },
  },

  // Team Settings - TL only
  {
    path: 'team-settings',
    loadComponent: () => import('./pages/team-settings/team-settings.component').then((m) => m.TeamSettingsComponent),
    canActivate: [authGuard, roleGuard],
    data: { permission: 'teamSettings' },
  },

  { path: '**', redirectTo: '/dashboard' },
];
